<script setup>
import { computed, onMounted } from 'vue'
import { useProfileStore } from '@/stores/profile'
import { useRequestsStore } from '@/stores/requests'

const profileStore = useProfileStore()
const requestsStore = useRequestsStore()

const profile = computed(() => profileStore.profile)
const userName = computed(() => {
    let name = ''

    if (profile.value.lastName) name += profile.value.lastName + ' '
    if (profile.value.name) name += profile.value.name + ' '
    if (profile.value.surname) name += profile.value.surname

    return name
})

onMounted(async () => {
    if (!profile.value.uuid) {
        await profileStore.readProfile()
    }
})
</script>

<template>
    <div class="asw-header-profile" v-if="Object.keys(profile).length">
        <router-link :to="'/users/' + profile.uuid" class="asw-header-profile__name">
            <span class="material-icons asw-header-profile__name-icon"> person </span>
            <div class="asw-header-profile__name-text">
                {{ userName }}
            </div>
        </router-link>
        <div class="asw-header-logout">
            <a href="#" class="asw-header-logout-link" @click.prevent="requestsStore.logout">
                <span class="material-icons asw-header-logout-icon"> logout </span>
            </a>
        </div>
    </div>
</template>

<style lang="scss">
@use '@/assets/styles/scss/components/header-profile';
</style>
